import React, { useState }  from "react";
import { useQueryClient } from '@tanstack/react-query';
// import { useNavigate } from "react-router-dom";
import { FormProvider } from "react-hook-form";
import { Input, DateInput, Select, Pagination, SortHeader, FileList } from "@components";
import { BoardFormModal } from "@pages";
import { useBoardList } from "@hooks";

const BoardList = () => {
    const {
        methods, data, isLoading, isError, error, watch, setValue, selectedItems, isAllChecked, onSubmit,
        handlePageChange, handleSelectAll, handleSelectItem, handleDelete, refreshList,
        pageIndex, recordCountPerPage, 
      } = useBoardList();

    const [formModalOpen, setFormModalOpen] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [selectedBoardNum, setSelectedBoardNum] = useState(null);
    const queryClient = useQueryClient();
    const handleRegister = (e) => {
        e.preventDefault();
        setIsEdit(false);     
        setSelectedBoardNum(null);
        setFormModalOpen(true);
      };
    const handleUpdate = (e) => {
        e.preventDefault();
        if (selectedItems.length === 0) {
            alert("수정할 항목을 선택해주세요.");
            return;
        } else if (selectedItems.length > 1) {
            alert("수정은 한 개 항목만 가능합니다.");
            return;
        }

        setIsEdit(true);
        setSelectedBoardNum(selectedItems[0]);
        setFormModalOpen(true);
    }
    const handleModalSuccess = (response) => {
      alert(response.message);

      queryClient.invalidateQueries(['fileDetails']);
      refreshList();
      
    };

    if (isLoading) {
        return <div>로딩 중...</div>;
    }
    if (isError) {
        console.log("isError:", error);
        return <div>오류가 발생했습니다: {error?.message || "알 수 없는 에러"}</div>;
    }

  return (
    <FormProvider {...methods}>
      <form onSubmit={methods.handleSubmit(onSubmit)}>
        <div className="contents-wrap">
          <div className="page-title-wrap">
            <h2><span className="icon-dot-circle"></span>안전법규및규정</h2>
          </div>

          <div className="tab-wrap">
            <ul>
              <li id="tabBtn1" className="on"><a href="/" title="산업안전보건법">산업안전보건법</a></li>
              <li id="tabBtn4"><a href="/" title="안전보건관계법령">안전보건관계법령</a></li>
              <li id="tabBtn2"><a href="/" title="중대재해처벌법">중대재해처벌법</a></li>
              <li id="tabBtn3"><a href="/" title="사내안전보건관리규정">사내안전보건관리규정</a></li>
            </ul>
          </div>

          <div className="tab-cont-wrap">
            <div className="tab-cont-01 on">
              <div className="search-wrap">
                <div className="search-row">
                  <div className="search-item date-picker-box">
                    <label>등록일</label>
                      <DateInput name="createStDate" />
                      <span className="separator">~</span>
                      <DateInput name="createEndDate" minDate={watch("createStDate")} />
                  </div>
                  {/* 
                  <div className="search-item">
                    <Radio label="예시1번" name="exm" value="e1" />
                    <Radio
                      label="예시2번"
                      name="exm"
                      value="e2"
                      className="ml10"
                    />
                  </div> */}
                  <div className="search-item">
                    <Select
                      name="searchCnd"
                      options={[
                        { key: "0", name: "제목" },
                        { key: "1", name: "내용" },
                      ]}
                      defaultOption="선택"
                      className="input-select"
                    />

                        {/* <Select
                            name="bizRegNo"
                            options={companyList}
                            defaultOption="업체를 선택하세요"
                            required
                            className="inp-sel-sub"
                            valueKey="bizRegNo" // key 값 (value)
                            labelKey="corpName" // 텍스트 보이는 이름
                            onChange={(e) => {
                              const selectedId = e.target.value;
                              setSelectedCompanyId(selectedId);
                              setValue('bizRegNo', selectedId,  { shouldValidate: true }); 
                            }}
                          /> */}

                    <Input
                      name="searchWrd"
                      placeholder="검색어를 입력하세요"
                      className="input-search"
                      style={{ width: "250px" }}
                    />
                  </div>
                  <div className="search-btn-container">
                    <button className="btn-search">조회</button>
                  </div>
                </div>
              </div>

                <section>
                  <div className="section-tit-wrap">
                    <h3 className="border-left-primary">
                      &nbsp;산업안전보건법
                      <span className="total-txt">
                        {" "} | 총 <span className="red">{data.totalCount}</span> 건
                      </span>
                    </h3>
                    <div className="btn-right-box">
                      <ul>
                        <li><a href="/main" title="엑셀" className="btn-excel" >엑셀</a></li>
                        {/* <li><a href="/" title="저장" className="btn-save" >저장</a></li> */}
                        <li><a href="/" title="등록" className="btn-write"  onClick={handleRegister}>등록</a></li>
                        <li><a href="/" title="수정" className="btn-update" onClick={handleUpdate}>수정</a></li>
                        <li><a href="/" title="삭제" className="btn-delete" onClick={handleDelete}>삭제</a></li>
                      </ul>
                    </div>
                  </div>
                  <div className="table-container overflow-x-auto table-list-wrapper">
                  <table className="table-list" style={{width:"100%"}}>
                    <colgroup>
                      <col style={{ width: "1%" }} />
                      <col style={{ width: "3%" }} />
                      <col style={{ width: "15%" }} />
                      <col style={{ width: "5%" }} />
                      <col style={{ width: "15%" }} />
                      <col style={{ width: "5%" }} />
                      <col style={{ width: "13%" }} />
                    </colgroup>
                    <thead>
                      <tr>
                        <th>
                        <input type="checkbox" checked={isAllChecked} onChange={handleSelectAll} />
                        </th>
                        <th>번호</th>
                        <SortHeader field="TITLE" label="제목" />
                        <SortHeader field="WRITER" label="담당자" />
                        <SortHeader field="CONTENT" label="내용" />
                        <SortHeader field="CREATED_AT" label="등록일" />
                        <th>파일</th>

                      </tr>
                    </thead>
                    <tbody>
                    {data?.resultList && data.resultList.length > 0 ? (
                      data.resultList.map((item, idx) => (
                        <tr 
                            key={item.boardNum}
                            onClick={() => handleSelectItem(item.boardNum)}
                            style={{ cursor: "pointer" }}>
                          <td onClick={(e) => e.stopPropagation()}>
                            <input type="checkbox" checked={selectedItems.includes(item.boardNum)} onChange={() => handleSelectItem(item.boardNum)} />
                          </td>
                          <td>{(pageIndex - 1) * recordCountPerPage + idx + 1}</td>
                          <td style={{textAlign:"left"}}>{item.title}</td>
                          <td>{item.writer}</td>
                          <td>{item.content}</td>
                          <td>{item.createdAt}</td>
                          <td><FileList atchFileId={item.atchFileId} updatedAt={item.updatedAt} showDelete={false} className="inline" onFileDelete={() => setValue("atchFileId", null)}/> </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={7} className="table-empty" style={{ textAlign: 'center' }}>
                          조회 결과가 없습니다.
                        </td>
                      </tr>
                    )}
                  </tbody>
                  </table>
                  </div>
                    {data?.paginationInfo && data.paginationInfo.totalRecordCount > 0 && (
                    <Pagination
                        totalPages={Math.ceil(
                        data.paginationInfo.totalRecordCount / data.paginationInfo.recordCountPerPage
                        )}
                        currentPage={pageIndex}
                        onPageChange={handlePageChange}
                        pageRangeDisplayed={10}
                    />
                    )}
                </section>
            </div>
          </div>
        </div>
      </form>
      <BoardFormModal
        isOpen={formModalOpen}
        onClose={() => setFormModalOpen(false)}
        isEdit={isEdit}
        boardNum={isEdit ? selectedBoardNum : null}
        onSuccess={handleModalSuccess}
      />
    </FormProvider>
  );
};

export {BoardList};
